module.exports = __webpack_public_path__ + "static/lframe-kiwibank-travel-loans-30a7ee78f137fd81afc345f0adb0886a.webp";